import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { CartModel, CartPart, LineModel, ConfigurationModel } from 'franke-trough-dependencies';
import { find as _find } from 'lodash';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';
import { AssemblyAccessoriesLabel } from '../Inputs';

export interface  AssemblyAccessoriesPartialCheckoutProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
}

export class AssemblyAccessoriesPartialCheckout extends React.Component<AssemblyAccessoriesPartialCheckoutProps> {
  public render() {
    return this.checkout && this.checkout.lines && this.checkout.lines.assemblyAccessories ? (
      <div className="assembly-accessories-partial-line">
        <span className="configuration-name">
          <FormattedMessage {...MESSAGES.assemblyAccessoriesTitle} />
        </span>
        <ul>
          {this.console && this.configuration && this.configuration.assemblyAccessories && this.configuration.assemblyAccessories.console && (
            <li>
              <FormattedMessage {...MESSAGES.assemblyAccessoriesConsoles} values={{
                qty: this.console.qty,
                part: <AssemblyAccessoriesLabel value={this.configuration.assemblyAccessories.console} />,
              }} />
            </li>
          )}
          {this.angleBar && (
            <li>
              <FormattedMessage {...MESSAGES.assemblyAccessoriesAngleBar} values={{
                qty: this.angleBar.qty,
              }} />
            </li>
          )}
          {this.safetyCatch && (
            <li>
              <FormattedMessage {...MESSAGES.assemblyAccessoriesSafetyCatch} values={{
                qty: this.safetyCatch.qty
              }} />
            </li>
          )}
        </ul>
      </div>
    ) : null;
  }

  private getLinePartByKey(key: string): LineModel | undefined {
    if (!this.checkout) {
      return;
    }
    
    const assemblyAccessories = this.checkout.lines && this.checkout.lines.assemblyAccessories;
    if (!assemblyAccessories) {
      return;
    }
    const consoles = _find(assemblyAccessories, ass => ass.part && (ass.part as CartPart).key === key);
    return consoles ? consoles : undefined;
  }

  private get console(): LineModel | undefined {
    return this.getLinePartByKey('console');
  }

  private get angleBar(): LineModel | undefined {
    return this.getLinePartByKey('angle_bar');
  }

  private get safetyCatch(): LineModel | undefined {
    return this.getLinePartByKey('safety_catch');
  }

  private get checkout(): CartModel |undefined {
    const { checkout } = this.props;
    return checkout && checkout.result;
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const AssemblyAccessoriesPartialCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(AssemblyAccessoriesPartialCheckout);

export default AssemblyAccessoriesPartialCheckoutComponent;